<!-- added currency context to set dynamic currency accrding to user -->
<ng-template cxOutletRef="cx-header" cxOutletPos="after">
  <vs-global-message></vs-global-message>
</ng-template>

<cx-storefront [class]="loggedIn ? '' : 'guest-storefront'"></cx-storefront>
